import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import AddJobsDialog from '../components/Dialog/AddFormDialog/AddJobsDialog';
import UpdateJobsDialog from '../components/Dialog/UpdateFormDialog/UpdateJobsDialog';
import Label from '../components/label';
import { deleteSelectedJobsMethod, getJobsMethod } from '../redux/slice/jobsSlice';
import JobsService from '../redux/api/JobsService';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'title', label: 'Job Title', alignRight: false },
  { id: 'companyName', label: 'Company Name', alignRight: false },
  { id: 'jobType', label: 'Job Type', alignRight: false },
  { id: 'skills', label: 'Skills', alignRight: false },
  { id: 'salary', label: 'Salary', alignRight: false },
  { id: 'noOfPositions', label: 'No. of Jobs', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'country', label: 'Country', alignRight: false },
  { id: 'lastDate', label: 'Last date', alignRight: false },
  { id: 'responsibilities', label: 'Responsibilities', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function JobsPage() {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.job);

  useEffect(() => {
    dispatch(getJobsMethod());
  }, [dispatch]);

  const [jobId, setJobId] = useState(null);

  const [selectedData, setSelectedData] = useState(null);

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openAddForm, setOpenAddForm] = useState(false);

  const [openEditForm, setOpenEditForm] = useState(false);

  const handleClickOpenAddForm = () => {
    setOpenAddForm(!openAddForm);
  };

  const handleClickOpenEditForm = () => {
    setOpenEditForm(!openEditForm);
  };

  const handleOpenMenu = (event, row) => {
    setJobId(row._id);
    setSelectedData(row);
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.data !== null && data.data !== undefined && data.data.map((n) => n._id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const filteredUsers = applySortFilter(
    data.data !== null && data.data !== undefined ? data.data : [],
    getComparator(order, orderBy),
    filterName
  );

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredUsers.length - page * rowsPerPage);

  const isNotFound = !filteredUsers.length && !!filterName;

  const handleSelectDeleteMethod = () => {
    dispatch(deleteSelectedJobsMethod(selected));
    setSelected([]);
  };

  const handleSubmit = async (status) => {
    const data = {
      status,
    };
    await JobsService.update(jobId, data)
      .then((res) => {
        console.warn(res);
        dispatch(getJobsMethod());
      })
      .catch((error) => {
        if (!error.response.data.message) {
          toast.error(error.message, { position: 'top-right' });
        } else {
          toast.error(error.response.data.message, { position: 'top-right' });
        }
        throw error;
      });
  };
  return (
    <>
      <Helmet>
        <title> Jobs | PakPrint Wishes </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Jobs
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleClickOpenAddForm}>
            Add New Job
          </Button>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            handleSelectDeleteMethod={handleSelectDeleteMethod}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={filteredUsers.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const {
                      _id,
                      title,
                      companyName,
                      jobType,
                      salary,
                      noOfPositions,
                      skills,
                      city,
                      country,
                      lastDate,
                      responsibilities,
                      description,
                      status,
                    } = row;
                    const selectedUser = selected.indexOf(_id) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, _id)} />
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Typography variant="subtitle2" noWrap>
                            {!title ? 'N/A' : title}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">{!companyName ? 'N/A' : companyName}</TableCell>
                        <TableCell align="left">{!jobType ? 'N/A' : jobType}</TableCell>
                        <TableCell align="left">{!skills ? 'N/A' : skills}</TableCell>
                        <TableCell align="left">{!salary ? 'N/A' : salary}</TableCell>
                        <TableCell align="left">{!noOfPositions ? 'N/A' : noOfPositions}</TableCell>
                        <TableCell align="left">{!city ? 'N/A' : city}</TableCell>
                        <TableCell align="left">{!country ? 'N/A' : country}</TableCell>
                        <TableCell align="left">{!lastDate ? 'N/A' : moment(lastDate).format('DD/MM/YYYY')}</TableCell>

                        <TableCell align="left" sx={{fontSize:'10px'}}>
                          {!responsibilities ? 'N/A' : <div dangerouslySetInnerHTML={{ __html: responsibilities.slice(0, 100) }} />}
                        </TableCell>
                        <TableCell align="left" sx={{fontSize:'10px'}}>
                          {!description ? 'N/A' : <div dangerouslySetInnerHTML={{ __html: description.slice(0, 100) }} />}
                        </TableCell>
                        <TableCell align="left">
                          <Label color={(status === 'Draft' && 'error') || 'success'}>{status}</Label>
                        </TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Link style={{ color: 'black', textDecoration: 'none' }} to={`/dashboard/jobs/applied-jobs/${jobId}`}>
          <MenuItem>
            <Iconify icon={'ic:outline-remove-red-eye'} sx={{ mr: 2 }} />
            View
          </MenuItem>
        </Link>
        <MenuItem
          onClick={() => {
            if (selectedData.status === 'Draft') {
              handleSubmit('Active');
              setOpen(false);
            } else {
              handleSubmit('Draft');
              setOpen(false);
            }
          }}
        >
          <Iconify icon={'material-symbols:file-copy'} sx={{ mr: 2 }} />
          Status
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClickOpenEditForm();
            setOpen(false);
          }}
        >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem
          sx={{ color: 'error.main' }}
          onClick={async () => {
            await JobsService.deletes(jobId)
              .then((res) => {
                console.warn(res);
                toast.success('Job deleted successfully');
                dispatch(getJobsMethod());
                setJobId(null);
                setOpen(false);
              })
              .catch((error) => {
                if (!error.response.data.message) {
                  toast.error(error.message, { position: 'top-right' });
                } else {
                  toast.error(error.response.data.message, { position: 'top-right' });
                }
                throw error;
              });
          }}
        >
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      <AddJobsDialog openAddForm={openAddForm} handleClickOpenAddForm={handleClickOpenAddForm} />
      <UpdateJobsDialog openEditForm={openEditForm} handleClickOpenEditForm={handleClickOpenEditForm} jobId={jobId} />
    </>
  );
}
